import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { ShieldCheck, Radar, Brain } from "lucide-react";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen lg:grid lg:grid-cols-2">
      {/* Left brand panel */}
      <div className="relative hidden overflow-hidden bg-card lg:flex lg:flex-col lg:justify-between lg:p-12">
        <div className="absolute inset-0 hero-glow" />
        <div className="absolute inset-0 grid-noise opacity-40" />
        <div className="relative"><Logo /></div>
        <div className="relative space-y-6">
          <h2 className="font-display text-3xl font-bold leading-tight">Understand Markets.<br />Find Signals.<br />Manage Risk.</h2>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-center gap-2"><Radar className="h-4 w-4 text-primary" /> Probabilistic AI signals across 5 markets</li>
            <li className="flex items-center gap-2"><Brain className="h-4 w-4 text-accent" /> AI Analyst grounded on structured data</li>
            <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-bullish" /> Risk-first paper trading & backtesting</li>
          </ul>
        </div>
        <div className="relative text-xs text-muted-foreground">© {new Date().getFullYear()} KREONIS · Demo data · Not investment advice</div>
      </div>

      {/* Right form panel */}
      <div className="flex min-h-screen flex-col justify-center px-4 py-10 sm:px-6 lg:px-12">
        <div className="mx-auto w-full max-w-md">
          <div className="mb-6 flex items-center justify-between lg:hidden"><Logo /><ThemeToggle /></div>
          <div className="hidden justify-end lg:flex"><ThemeToggle /></div>
          <h1 className="mt-4 font-display text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
          {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-6">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
          <div className="mt-8 text-center"><Link to="/" className="text-xs text-muted-foreground hover:text-foreground">← Back to home</Link></div>
        </div>
      </div>
    </div>
  );
}
